import { getMimeTypes } from '@common/utils/file'

export const ICON_WIDTH = 24
export const GAP = 12
export const SEPARATOR_WIDTH = 1
export const MORE_ACTION_WIDTH = 20

// It closes popover instantly if user hovers over other dropdown items until dropdown disappear
export const DROPDOWN_DISAPPEARING_DURATION = 200
// It reopens gifs list instantly when user clicks gif icon
export const GIF_LIST_DISAPPEARING_DURATION = 100

export const ACCEPTED_MEDIA_MIME_TYPES = getMimeTypes({
  types: ['video', 'image'],
}).join(',')
